import { ChevronRightOutlined } from '@mui/icons-material';
import { Chip, ChipProps } from '@mui/material';
import React from 'react';
import CAppTooltip from '../../../app/components/CAppTooltip';

type CChipFundProps = ChipProps & {
	onClick: () => void;
	displayTooltip?: boolean;
};
const CChipFund = (props: CChipFundProps) => {
	const { displayTooltip } = props;

	const componentChip = (
		<Chip
			className="fund-chip"
			color="default"
			onClick={() => props.onClick()}
			onDelete={() => props.onClick()}
			deleteIcon={<ChevronRightOutlined />}
			label={props.label}
			// disabled={props.disabled}
			sx={{
				padding: '6px',
				display: 'block-inline',
				backgroundColor: '#E3E8F0',
				fontFamily: 'Poppins',
				fontStyle: 'normal',
				fontWeight: 400,
				fontSize: '0.9rem',
				margin: '0px 5px 5px 0px',
				lineHeight: '1.5rem',
				color: props.disabled ? '#8799B4' : '#1A2B48',
				':disabled': {
					color: '#8799B4',
				},
				':hover': {
					backgroundColor: '#E3E8F0',
				},
				'& .MuiChip-deleteIcon': {
					color: props.disabled ? '#8799B4' : '#1A2B48',
				},
			}}
		/>
	);
	return (
		<>
			{displayTooltip ? (
				<CAppTooltip title={props.label} placement="right" disableInteractive>
					{componentChip}
				</CAppTooltip>
			) : (
				<>{componentChip}</>
			)}
		</>
	);
};

export default CChipFund;
